export default "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAADQAQCdASoQAAgAAsBMJQBOgCHhgJuYgAD+9kqiecTnV6k8+zd2AWRQn3hmGvPwCn3Gkr7B0pFT8+MAjq5riICJgAA=";